import { mapState } from "vuex";
import diagnostics, { DEBUG, INFO, WARNING, ERROR } from "@/services/diagnostics/diagnosticsService";

export default {
    computed: {
        ...mapState({
            diagnosticsEnabled: state => state.diagnosticsEnabled
        })
    },
    methods: {
        $_diagnostics_getComponentName: function () {
            const vm = this;
            // Vue 3: check for component name
            return vm.$options.name || vm.$options.__name || 'Anonymous';
        },
        logDebug: async function (message, data = null) {
            if (this.diagnosticsEnabled) {
                await diagnostics.log(DEBUG, message, this.$route.path, this.$_diagnostics_getComponentName(), data);
            }
        },
        logInfo: async function (message, data = null) {
            if (this.diagnosticsEnabled) {
                await diagnostics.log(INFO, message, this.$route.path, this.$_diagnostics_getComponentName(), data);
            }
        },
        logWarning: async function (message, data = null) {
            if (this.diagnosticsEnabled) {
                await diagnostics.log(WARNING, message, this.$route.path, this.$_diagnostics_getComponentName(), data);
            }
        },
        logError: async function (message, data = null) {
            if (this.diagnosticsEnabled) {
                await diagnostics.log(ERROR, message, this.$route.path, this.$_diagnostics_getComponentName(), data);
            }
        }
    }
}